import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/19_card_back_rosehip/19_card_back_rosehip"
 * Contains 1 texture(s)
 */
export class CardsBacks19CardBackRosehipAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/19_card_back_rosehip/19_card_back_rosehip';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '19_rosehip.png'
    ] as const;
}
